module.exports = __webpack_public_path__ + "static/media/coach-jimmy.1bdd4f11.png";